import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {IndexEntityService, ReferenceService} from '../../../apiModule1';
import {NgClass, NgStyle} from '@angular/common';
import {map} from 'rxjs/operators';
import {BehaviorSubject, Observable, of, switchMap} from 'rxjs';
import {MultiSelect2Component} from '../../../../shared/components/multi-select2/multi-select2.component';
import {mapToCanActivate} from '@angular/router';

@Component({
    selector: 'pas-filter-dialog',
    standalone: true,
    imports: [
        MatIcon,
        MatIconButton,
        ReactiveFormsModule,
        MatButton,
        NgClass,
        NgStyle,
        MultiSelect2Component
    ],
    templateUrl: './filter-dialog.component.html',
    styleUrl: './filter-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDialogComponent implements OnInit {
    dialogRef = inject(MatDialogRef<FilterDialogComponent>);
    referenceService = inject(ReferenceService);
    data: Record<string, any> = inject(MAT_DIALOG_DATA)
    indexEntityService = inject(IndexEntityService);
    cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

    archiveStatuses: Status[] = []
    filteredIndexes: Observable<IndexEntry[]> = of([])
    dataIndexes: IndexEntry[] = []

    get filteresIndexesMaped(): Observable<string[]> {
        return this.filteredIndexes.pipe(map(v => v.map(i => i.name)))
    }

    get dataIndexesNames(): string[] {
        return this.dataIndexes.map(v => v.name);
    }

    private selectedIndex?: IndexEntry;

    get archiveStatusesNames(): string[] {
        return this.archiveStatuses.map(v => v.name);
    }

    isAutocompleteOpen: boolean = false;
    isAutocompleteOpen1: boolean = false;
    isAutocompleteOpen2: boolean = false;

    fillTypes: { id: number; name: string, label: string }[] = [
        {id: 0, name: 'Number_Enter', label: 'Ввод числа'},
        {id: 1, name: 'List_Select', label: 'Выбор из списка'},
        {id: 2, name: 'Ias_Sport', label: 'ИАС Спорт'}
    ];

    form = new FormGroup({
        archive: new FormControl(),
        index: new FormControl(),
        fillTypes: new FormControl(),
    })

    dataFromIndexControl$ = new BehaviorSubject<string>(''); //для генерации новых запросов при вводе запроса в input

    onNoClick(): void {
        this.dialogRef.close();
    }


    ngOnInit(): void {
        console.log('filter-dialog data', this.data);


        this.dataFromIndexControl$
            .pipe(switchMap((v: string) =>
                this.indexEntityService.apiIndexFilterlistGet({filteredObjectName: 'index', searchString: v})
                    .pipe(map(v => v?.values))
            )).subscribe(v => {
            this.dataIndexes = v;
        })

        //задаем начальные значения для контролов приходящие в data
        this.data && this.data['indexEntityIds'] && this.form.get('index')!.setValue(this.data['indexEntityIds'], {emitEvent: false});
        this.data && this.data['fillTypes'] && this.form.get('fillTypes')!.setValue(this.data['fillTypes'], {emitEvent: false});
        this.data && this.data['statusIds'] && this.form.get('archive')!.setValue(this.data['statusIds'], {emitEvent: false});

        this.referenceService.apiReferenceStatusesGet().pipe(map(v => v.values)).subscribe((v: Status[]) => {
            this.archiveStatuses = v;
            const statusIdFromData = this.data && this.data['statusId'];
            const statusSelect = this.archiveStatuses.find(s => s.id === +(statusIdFromData))?.name;
            this.form.get('archive')!.setValue(statusSelect);
        })

        this.form.get('index')!.valueChanges
            .subscribe((v: IndexEntry | string) => {
                console.log('index', v);
            })

        this.form.get('fillTypes')!.valueChanges.subscribe(v => {
            console.log('fillTypes', v)
        });
    }

    onReset(): void {
        this.form.reset();
    }

    onApply() {

        const res = {
            statusIds: this.form.get('archive')!.value,
            indexEntityIds: this.form.get('index')!.value,
            fillTypes: this.form.get('fillTypes')!.value
        }

        this.dialogRef.close(res);
    }


    onInputIndexChange(event: string): void {
        if (typeof event !== "string") return
        this.dataFromIndexControl$.next(event);
    }

    protected readonly mapToCanActivate = mapToCanActivate;


}
